import { render, staticRenderFns } from "./OccurrenceDetailModal.vue?vue&type=template&id=59deb93c&scoped=true&"
import script from "./OccurrenceDetailModal.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceDetailModal.vue?vue&type=style&index=0&id=59deb93c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59deb93c",
  null
  
)

export default component.exports